<template>
    <div id="div_activeHud_container" :style="{
        '--main-color': mainColor,
    }" v-if="showHud">

        <template v-if="activePreviewAnnotation != null && activePreviewAnnotation.reportText?.length > 0">
            <div class="active_tooth_region">
                <reportLabelAnnotationItem
                    :annotation="activePreviewAnnotation" />
            </div>
        </template>
        <template v-else>
            <span class="activeDente hudSpan">
                {{ activeDenteTool?.label?.text }}
            </span>
        </template>
        <svg v-if="activeDenteTool != null" class="denteSvg"
            style="overflow:visible; align-self: center; justify-self: center;" :style="{
                width: adInfo.width + 'px',
                height: adInfo.height + 'px'
            }">
            <defs>
                <filter id="hudTooth" x="-250%" y="-250%" width="500%" height="500%">
                    <feComponentTransfer>
                        <feFuncR type="table" tableValues="0.05"></feFuncR>
                        <feFuncG type="table" tableValues="0.05"></feFuncG>
                        <feFuncB type="table" tableValues="0.05"></feFuncB>
                    </feComponentTransfer>
                    <feMorphology operator="dilate" :radius="toolConfidence.fRadius / GET_waZoomScale" />
                    <feGaussianBlur result="out" :stdDeviation="toolConfidence.fStdDev / GET_waZoomScale" />
                    <feBlend in="SourceGraphic" in2="out" mode="normal" />
                </filter>
                <radialGradient id="grad" cx="50%" cy="50%" r="100%" fx="50%" fy="50%">
                    <stop offset="0%" style="stop-color:#e3e3de; stop-opacity:0" />
                    <stop offset="100%" style="stop-color:#909090;stop-opacity:1" />
                </radialGradient>
            </defs>

            <g :transform="adInfo.transform">
                <path id="path_activeHud" filter="url(#hudTooth)" v-bind="{
                    d: d_curva(activeDenteTool) + ' Z',
                    stroke: toothColor,
                    strokeWidth: 3,
                    fill: 'url(#grad)',
                    opacity: 0.6
                }">
                </path>
            </g>
        </svg>

        <span class="active_locations" v-if="activeInternalLocationItems != null">
            <section class="active_locations_group" v-if="activeInternalLocationItems.faces.length > 0">
                <h5 class="title">Faces</h5>
                <div class="list">
                    <span class="list__item" v-for="(location, index) in activeInternalLocationItems.faces"
                        :key="index">
                        <span style="font-weight: bold;" :style="{ color: location.color }">{{ location.text }}</span>
                        <span v-if="index < activeInternalLocationItems.faces.length - 1"> - </span>
                    </span>
                </div>
            </section>
            <section class="active_locations_group" v-if="activeInternalLocationItems.portions.length > 0">
                <h5 class="title">Porções</h5>
                <div class="list">
                    <span class="list__item" v-for="(location, index) in activeInternalLocationItems.portions"
                        :key="index">
                        <span style="font-weight: bold;" :style="{ color: location.color }">{{ location.text }}</span>
                        <span v-if="index < activeInternalLocationItems.portions.length - 1"> - </span>
                    </span>
                </div>
            </section>
        </span>
    </div>
</template>

// =========================================================================================
// =========================================================================================

<script>
import { mapGetters, mapState } from 'vuex';
import { gConsts } from '@/globals/gConsts';
import { nodes } from '@/globals/nodes';
import { paths } from '../../mixins/paths';
import { evtBus } from '@/main';
import { LabelAnnotation, LabelAnnotationLocation } from '@/features/report/models';
import { anotacaoUtils } from '@/features/anotacoes/lib/AnotacaoUtils';

import reportLabelAnnotationItem from '@/features/report/components/text/reportLabelAnnotationItem.vue';

// =========================================================================================

export default {
    name: 'activeHudCMP',

    components: {
        reportLabelAnnotationItem
    },

    // -----------------------------------------------------------------

    props: {
    },

    // -----------------------------------------------------------------

    mixins: [paths],

    // -----------------------------------------------------------------

    data() {
        return {
            toothColor: '#e3e3de',

            toolConfidence: {
                fRadius: 7,
                fStdDev: 5
            },

            active: {
                labelId: null,
                especificacao: null,
                denteId: null,
                toothRegion: [],
                externalLocations: [],
                internalLocations: {
                    faces: [],
                    portions: []
                }
            }
        }
    },

    // -----------------------------------------------------------------

    computed: {
        ...mapState([
        ]),

        // -----------------------------------------------------------------

        ...mapGetters([
            'GET_denteTools',
            'GET_waZoomScale'
        ]),

        // -----------------------------------------------------------------

        adInfo() {
            var translate, scale, width, height, ratio,
                minX = 999999,
                minY = 999999,
                maxX = 0,
                maxY = 0,
                pts = this.activeDenteTool?.coords.pts || [];

            pts.forEach(pt => {
                minX = Math.min(minX, pt.x);
                minY = Math.min(minY, pt.y);
                maxX = Math.max(maxX, pt.x);
                maxY = Math.max(maxY, pt.y);
            });
            width = maxX - minX;
            height = maxY - minY;

            ratio = width / height;
            if (ratio > 0.75) {
                scale = 100 / width;
            } else {
                scale = 150 / height;
            }
            translate = 'translate(' + -minX + ', ' + -minY + ')';

            return {
                transform: 'scale(' + scale + ') ' + translate,
                width: width * scale,
                height: height * scale
            }
        },

        // -----------------------------------------------------------------

        showHud() {
            if (this.activePreviewAnnotation) {
                return this.activePreviewAnnotation.reportText?.length > 0;
            }
            return this.activeDenteTool != null;
        },

        // -----------------------------------------------------------------

        activeLabelAnnotationType() {
            if (!this.active.labelId) {
                return null;
            }
            return anotacaoUtils.getLabelAnnotationTypeById(this.active.labelId);
        },

        activeLabelHasInternalLocations() {
            if (!this.active.labelId)
                return false;
            const localizacaoInternaInfo = anotacaoUtils.getLocalizacaoInternaInfoByLabelId(this.active.labelId);
            if (!localizacaoInternaInfo)
                return false;
            return localizacaoInternaInfo?.localizacao?.face?.lista?.length > 0 || localizacaoInternaInfo?.localizacao?.porcao?.lista?.length > 0;
        },

        activeDenteColor() {
            if (!this.activeDenteTool)
                return gConsts.label.colors.DEFAULT;
            const color = nodes.getNode(this.activeDenteTool.label.id)?.layout.color ?? gConsts.label.colors.DEFAULT;
            return gConsts.ui.prettyColors[color] ?? color;
        },

        activeDenteTool() {
            if (this.active.especificacao && !anotacaoUtils.especificacaoPermiteDentes(this.active.especificacao)) {
                return null;
            }
            if (this.activeToothRegionItems.length > 0) {
                if (this.activeToothRegionItems.length == 1) {
                    return this.GET_denteTools.find(tool => tool.label.id == this.activeToothRegionItems[0].id);
                }
                return null;
            }

            if (!this.active.denteId)
                return null;
            
            return this.GET_denteTools.find(tool => tool.label.id == this.active.denteId);
        },

        mainColor() {
            if (this.activeToothRegionItems.length > 0) {
                return this.activeToothRegionItems.length == 1 ? this.activeToothRegionItems[0].color : undefined;
            }
            if (this.activeExternalLocationItems.length > 0 && this.activeDenteTool == null) {
                return this.activeExternalLocationItems.length == 1 ? this.activeExternalLocationItems[0].color : undefined;
            }
            return this.activeDenteColor;
        },

        activeInternalLocationItems() {
            if (this.activeDenteTool == null && this.activeToothRegionItems.length == 0)
                return null
            if (this.active.labelId && !this.activeLabelHasInternalLocations)
                return null;

            return {
                faces: this.active.internalLocations.faces.map(this.mapLocationTermToItem),
                portions: this.active.internalLocations.portions.map(this.mapLocationTermToItem)
            }
        },

        activeToothRegionItems() {
            if (this.active.especificacao && !anotacaoUtils.especificacaoPermiteDentes(this.active.especificacao)) {
                return [];
            }
            // console.log('activeToothRegionItems', this.active.toothRegion.join(', '))
            return this.active.toothRegion.map(denteId => {
                const denteNode = nodes.getNode(denteId);
                return {
                    id: denteId,
                    text: denteNode.layout.caption,
                    color: gConsts.ui.prettyColors[denteNode.layout.color] ?? denteNode.layout.color
                }
            });
        },

        activeExternalLocationItems() {
            return this.active.externalLocations.map(locationId => {
                const locationNode = nodes.getNode(locationId);
                return {
                    id: locationId,
                    text: locationNode.layout.caption,
                    color: gConsts.ui.prettyColors[locationNode.layout.color] ?? locationNode.layout.color
                }
            });
        },

        activePreviewAnnotation() {
            if (this.activeToothRegionItems.length == 0 && this.activeExternalLocationItems.length == 0) {
                return null;
            }
            if (this.activeLabelAnnotationType == gConsts.node.report.annotation.types.TOOTH && this.active.denteId)
                return null;
            // Configuro anotacao mesmo sem label ativo para pelo menos mostrar as regioes anatomicas ou dentes ativos
            let especificacao = undefined;
            let annotationType = this.activeLabelAnnotationType;
            if (!annotationType) {
                if (this.activeToothRegionItems.length > 0)
                    annotationType = gConsts.node.report.annotation.types.RTOOTH;
                else if (this.activeExternalLocationItems.length > 0 && !this.activeDenteTool)
                    annotationType = gConsts.node.report.annotation.types.ANAT_ONLY;
            }

            if (!annotationType)
                return null;

            if (this.active.labelId) {
                especificacao = this.active.especificacao;
            }

            return new LabelAnnotation(
                annotationType,
                undefined,
                new LabelAnnotationLocation(
                    especificacao,
                    this.activeExternalLocationItems.map(item => {
                        return {
                            id: item.id,
                            text: item.text,
                            color: item.color,
                            porcoes: []
                        }
                    }),
                    this.activeToothRegionItems.map(item => {
                        return {
                            id: item.id,
                            text: item.text,
                            color: item.color,
                            faces: [],
                            porcoes: []
                        }
                    })
                )
            );
        },

    },

    // -----------------------------------------------------------------

    methods: {
        mapLocationTermToItem(location) {
            return {
                text: this.mapTermToLabel(location),
                color: gConsts.label.colors.toothInternal[location.toUpperCase()]
            }
        },
        mapTermToLabel(term) {
            return {
                'coroa__incisal': 'incisal (coroa)',
                'coroa__oclusal': 'oclusal (coroa)',
                'coroa__cervical': 'cervical (coroa)',
                'coroa__mesial': 'mesial (coroa)',
                'coroa__distal': 'distal (coroa)',
                'raiz__distal': 'distal (raiz)',
                'raiz__mesial': 'mesial (raiz)',
                'raiz__cervical': 'cervical (raiz)',
                'raiz__apical': 'apical (raiz)',
                'raiz__media': 'média (raiz)',
                'dente_completo__coroa': 'coroa',
                'dente_completo__raiz': 'raiz',
                'media': 'média',
            }[term] || term;
        },
        onActiveLocationsUpdated(event) {
            if (event.dentes !== undefined)
                this.active.toothRegion = event.dentes;
            if (event.regioesAnatomicas !== undefined)
                this.active.externalLocations = event.regioesAnatomicas;
            if (event.especificacao !== undefined)
                this.active.especificacao = event.especificacao;
        },
        onActiveInternalLocationsUpdated(event) {
            this.active.internalLocations = event.locations;
        },
        onActiveDenteUpdated(denteId) {
            this.active.denteId = denteId;
        },
        onActivateNode(payload) {
            this.active.labelId = payload.label;
        }
    },

    // -----------------------------------------------------------------

    // Lifecycle hooks
    created() {
    },

    // -----------------------------------------------------------------

    mounted() {

        evtBus.$on('evt_medidor_activeLocations_updated', this.onActiveLocationsUpdated);
        evtBus.$on('evt_medidor_activeInternalLocations_updated', this.onActiveInternalLocationsUpdated);
        evtBus.$on('evt_medidor_activeDente_updated', this.onActiveDenteUpdated);
        evtBus.$on('evt_activateNode', this.onActivateNode);
    },

    // -----------------------------------------------------------------
}
</script>

// =========================================================================================
// =========================================================================================

<style scoped>

#div_activeHud_container {
    text-align: center;
    min-width: 160px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0px;
    padding-bottom: 10px;
    position: absolute;
    top: 30px;
    left: 50px;
    background: rgba(250, 250, 250, 0.9);
    border: 2px solid color-mix(in srgb, var(--main-color, #ccc) 50%, transparent);
    overflow: hidden;
}

.activeDente {
    grid-area: activeDente;
    color: var(--main-color);
}

.active_tooth_region {
    grid-area: activeDente;
    padding: var(--spacing-md) var(--spacing-sm);
}

.active_locations {
    grid-area: activeInternalLocations;
    padding-inline: 5px;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-sm);
}

.active_locations_group {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.active_locations_group .title {
    margin: 0;
    padding: 0;
    font-size: var(--text-xxs);
    letter-spacing: var(--tracking-wide);
    line-height: var(--leading-normal);
    text-transform: uppercase;
    font-weight: bold;
    color: var(--color-text-secondary);
}

.active_locations_group .list {
    display: inline;
}

.active_locations_group .list__item {
    font-size: var(--text-xs);
    color: black;
    line-height: 1;
}

.denteSvg {
    grid-area: denteSvg;
    padding-block: 10px;
}

.activeLabel {
    grid-area: activeLabel;
}

.hudSpan {
    font-weight: bolder;
    font-size: 70px;
    /* -webkit-text-stroke-color: black;
    -webkit-text-stroke-width: 1px; */
}
</style>